import { object } from '@/core/utils/validation';
import { pickingItemSchema, taskSchema } from './SocketMessageBase.yup';
const pickedFromStockMessageSchema = object({
    task: taskSchema.required(),
    pickingItem: pickingItemSchema.required(),
}).noUnknown(true);
export { pickedFromStockMessageSchema };
